import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MAIN_SITE_URL, categories } from '@/utils/constants';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const [mobileGuideOpen, setMobileGuideOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const guideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (guideRef.current && !guideRef.current.contains(event.target as Node)) {
        setGuideOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-sm">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-file-list-3-line text-xl text-primary-600"></i>
          </div>
          <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
            Sugargoo Spreadsheet
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-home-4-line text-xs"></i>
            </span>
            Home
          </Link>

          <div ref={guideRef} className="relative">
            <button
              onClick={() => setGuideOpen(!guideOpen)}
              className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
            >
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-book-open-line text-xs"></i>
              </span>
              Shopping Guide
              <span className={`w-3 h-3 flex items-center justify-center transition-transform duration-200 ${guideOpen ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-xs"></i>
              </span>
            </button>

            {guideOpen && (
              <div className="absolute top-full left-0 mt-2 w-64 bg-background-50 border border-background-200/70 rounded-lg shadow-lg z-40 py-2">
                <Link to="/sugargoo-spreadsheet-guide" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-file-list-3-line text-xs"></i>
                  </span>
                  Spreadsheet Complete Guide
                </Link>
                <Link to="/sugargoo-review" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-star-line text-xs"></i>
                  </span>
                  Sugargoo Review
                </Link>
                <Link to="/sugargoo-shipping-cost" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-ship-line text-xs"></i>
                  </span>
                  Shipping Cost Guide
                </Link>
                <Link to="/sugargoo-coupon" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-coupon-line text-xs"></i>
                  </span>
                  Coupon &amp; Savings
                </Link>
                <Link to="/sugargoo-warehouse" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-store-2-line text-xs"></i>
                  </span>
                  Warehouse Guide
                </Link>
                <Link to="/is-sugargoo-legit" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-shield-check-line text-xs"></i>
                  </span>
                  Is Sugargoo Legit?
                </Link>
                <Link to="/sugargoo-finds" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-fire-line text-xs"></i>
                  </span>
                  Best Finds
                </Link>
                <Link to="/sugargoo-beginner-guide" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-user-line text-xs"></i>
                  </span>
                  Beginner Guide
                </Link>
                <Link to="/sugargoo-discount-code" onClick={() => setGuideOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-percent-line text-xs"></i>
                  </span>
                  Discount Codes
                </Link>
              </div>
            )}
          </div>

          <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Categories</a>
          <a href="#what-is" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">About</a>
          <a href="#article" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Articles</a>

          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-xs"></i>
            </span>
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
          <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors py-2.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-home-4-line text-sm"></i>
            </span>
            Home
          </Link>

          <button
            onClick={() => setMobileCatOpen(!mobileCatOpen)}
            className="flex items-center justify-between w-full text-sm text-foreground-600 hover:text-primary-600 transition-colors py-2.5 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-grid-line text-sm"></i>
              </span>
              Product Categories
            </span>
            <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-xs"></i>
            </span>
          </button>

          {mobileCatOpen && (
            <div className="pl-8 flex flex-col gap-0.5 border-l-2 border-background-200/70 ml-2.5 mb-2">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center justify-between text-xs text-foreground-600 hover:text-primary-600 transition-colors py-2 whitespace-nowrap"
                >
                  <span className="flex items-center gap-1.5">
                    <span className="w-1 h-1 rounded-full bg-primary-400"></span>
                    {cat.name}
                  </span>
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs text-foreground-400"></i>
                  </span>
                </a>
              ))}
            </div>
          )}

          <button
            onClick={() => setMobileGuideOpen(!mobileGuideOpen)}
            className="flex items-center justify-between w-full text-sm text-foreground-600 hover:text-primary-600 transition-colors py-2.5 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-book-open-line text-sm"></i>
              </span>
              Shopping Guide
            </span>
            <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${mobileGuideOpen ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-xs"></i>
            </span>
          </button>

          {mobileGuideOpen && (
            <div className="pl-8 flex flex-col gap-0.5 border-l-2 border-background-200/70 ml-2.5 mb-2">
              {[
                { to: '/sugargoo-spreadsheet-guide', label: 'Spreadsheet Complete Guide' },
                { to: '/sugargoo-review', label: 'Sugargoo Review' },
                { to: '/sugargoo-shipping-cost', label: 'Shipping Cost Guide' },
                { to: '/sugargoo-coupon', label: 'Coupon & Savings' },
                { to: '/sugargoo-warehouse', label: 'Warehouse Guide' },
                { to: '/is-sugargoo-legit', label: 'Is Sugargoo Legit?' },
                { to: '/sugargoo-finds', label: 'Best Finds' },
                { to: '/sugargoo-beginner-guide', label: 'Beginner Guide' },
                { to: '/sugargoo-discount-code', label: 'Discount Codes' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-1.5 text-xs text-foreground-600 hover:text-primary-600 transition-colors py-2 whitespace-nowrap"
                >
                  <span className="w-1 h-1 rounded-full bg-primary-400"></span>
                  {link.label}
                </Link>
              ))}
            </div>
          )}

          <a href="#categories" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors py-2.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-price-tag-3-line text-sm"></i>
            </span>
            Categories
          </a>

          <a href="#what-is" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors py-2.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-information-line text-sm"></i>
            </span>
            About
          </a>

          <a href="#article" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors py-2.5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-article-line text-sm"></i>
            </span>
            Articles
          </a>

          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            onClick={() => setMobileOpen(false)}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 mt-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-xs"></i>
            </span>
          </a>
        </div>
      )}
    </header>
  );
}